import React from 'react';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
// Optionally import FormHelperText if you want to display error messages
// import FormHelperText from '@material-ui/core/FormHelperText';

const styles = theme => ({
  addButton: {
    position: 'fixed',
    right: 30,
    bottom: 200,
  },
  text: {
    fontSize: '18px',
  },
});

class AiContextNewFormDialog extends React.Component {
  state = {
    open: false,
    preamble: '',
    general_rules: '',
    rag_rules: '',
    active: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleRequestClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
    }
  };

  addRow = action => {
    const { preamble, general_rules, rag_rules, active } = this.state;
    action({
      preamble,
      general_rules,
      rag_rules,
      active,
    });
  };

  render () {
    const { classes, error, close } = this.props;
    console.log(this.props);
    // If the parent passes close = true after creation, we can close the dialog
    if (close) this.handleRequestClose();

    return (
      <div>
        {/* FAB (Floating Action Button) to launch the dialog */}
        <Button
          variant="fab"
          color="primary"
          aria-label="add"
          className={classes.addButton}
          onClick={this.handleClickOpen}
        >
          <AddIcon />
        </Button>

        {/* Dialog for creating a new AI context */}
        <Dialog open={this.state.open} onClose={this.handleRequestClose}>
          <DialogTitle className={classes.text}>Add AI Context</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              required
              id="preamble"
              label="Preamble"
              className={classes.textField}
            fullWidth
              onChange={e => this.setState({ preamble: e.target.value })}
            />
            <TextField
              margin="dense"
              required
              id="general_rules"
              label="General Rules"
              className={classes.textField}
              fullWidth
              onChange={e => this.setState({ general_rules: e.target.value })}
            />
            <TextField
              margin="dense"
              required
              id="rag_rules"
              label="RAG Rules"
              className={classes.textField}
              fullWidth
              onChange={e => this.setState({ rag_rules: e.target.value })}
            />
            <hr/>
            <TextField
              margin="dense"
              label="Active?"
              style={{ marginTop: '20px' }}
              fullWidth
              // A simple check
              helperText="Check to make this the active AI context"
            />
            <input
              type="checkbox"
              checked={this.state.active}
              onChange={e => this.setState({ active: e.target.checked })}
              style={{ transform: 'scale(1.5)', marginLeft: '10px' }}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleRequestClose} className={classes.text} color="primary">
              Cancel
            </Button>
            <Button
              className={classes.text}
              onClick={() => this.addRow(this.props.action)}
              disabled={!this.state.preamble || !this.state.general_rules || !this.state.rag_rules}
            >
              Add
            </Button>
          </DialogActions>

          {/* Uncomment if you want to show error messages under the actions */}
          {/* {error && <FormHelperText error>{error}</FormHelperText>} */}
        </Dialog>
      </div>
    );
  }
}

const AiContextNewFormDialogWithStyles = withStyles(styles)(AiContextNewFormDialog);
export default AiContextNewFormDialogWithStyles;